import { createSelector } from "reselect";

const selectDistro = (state) => state.distro;

export const selectCurrentDistro = createSelector(
  [selectDistro],
  (distro) => distro.currentDistro
);
